/**
 * Shared constants and tiny helpers for the inline voice-mode composer.
 * No audio computation lives here — amplitude/bar data arrives via CSS
 * custom properties (`--vc-level`, `--vc-b0`..`--vc-b4`) set by the parent.
 */

export const VOICE_PHASES = ['connecting', 'listening', 'thinking', 'speaking'];

/**
 * i18n key for a phase label. Falls back to 'listening'.
 * @param {string} phase
 * @returns {string} e.g. 'VoiceMode.listening'
 */
export const phaseLabelKey = phase => `VoiceMode.${phase || 'listening'}`;

/**
 * Agent (assistant) accent hue. Leans violet; derived from the theme chart
 * series so it adapts to light/dark, with a safe fallback.
 * @param {object} theme MUI theme
 * @returns {string}
 */
export const agentHue = theme => theme.palette.colorChartSeries?.[1] || '#9d62e5';

/**
 * User accent hue (indigo / primary).
 * @param {object} theme MUI theme
 * @returns {string}
 */
export const userHue = theme => theme.palette.primary.main;

/**
 * Whether the agent currently "holds the floor" (drives tint selection).
 * @param {string} phase
 * @returns {boolean}
 */
export const isAgentFloor = phase => phase === 'thinking' || phase === 'speaking';

/** Morph/transition duration (ms) for phase changes. */
export const MORPH_MS = 420;
